import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import I18n from '/src/utils/translations'
import { MdLocationOn, MdEdit } from 'react-icons/md'
import { isPresent } from '/src/utils/refinements'
import useInputChange from '/src/ui/core/inputs/input_change'
import useInputError from '/src/ui/core/inputs/input_error'
import GPSModal from '/src/ui/core/popups/gps_modal'

export default function InputGPS({ inputProps }) {
  const { 
    value,
    onChange,
    readOnly = false, 
    required = false,
    title,
    id,
    className
  } = inputProps
  
  const [data, setData] = useState('')
  const [showModal, setShowModal] = useState(false)
  
  const [inputValue, onInputChange] = useInputChange({ id, value, onChange })
  const error = useInputError({ inputValue, title, required })
  
  const isEditable = !readOnly

  const inputClass = () => {
    const classes = ['gps-form-text']
    if (isEditable) classes.push('gps-clickable')
    if (className) classes.push(className)
    if (error) classes.push('input-error')
    return classes.join(' ')
  }

  useEffect(() => {
    if (!inputValue) {
      setData(I18n.t('form.inputs.gps.without_location'))
    } else {
      const [latitude, longitude] = isPresent(inputValue)
        ? JSON.parse(inputValue)
        : [0, 0]

      if (latitude && longitude) {
        setData(`${parseFloat(latitude).toFixed(6)}, ${parseFloat(longitude).toFixed(6)}`)
      } else {
        setData(I18n.t('form.inputs.gps.without_location'))
      }
    }
  }, [inputValue])

  const handleGPSClick = () => {
    if (isEditable) {
      setShowModal(true)
    }
  }

  const handleModalSave = (gpsValue) => {
    if (onInputChange) {
      onInputChange({ target: { value: gpsValue } })
    }
    setShowModal(false)
  }

  const handleModalClose = () => {
    setShowModal(false)
  }

  return (
    <>
      <div 
        className={inputClass()}
        title={title || data}
        onClick={handleGPSClick}
        role={isEditable ? "button" : undefined}
        tabIndex={isEditable ? 0 : -1}
        onKeyDown={isEditable ? (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleGPSClick()
          }
        } : undefined}
        style={{ cursor: isEditable ? 'pointer' : 'default' }}
      >
        <span className="icon">
          <MdLocationOn />
        </span>
        <span className="gps-button-text">{data}</span>
        {isEditable && (
          <span className="gps-edit-icon">
            <MdEdit />
          </span>
        )}
      </div>
      <div className="error-label">{error}</div>
      
      <GPSModal
        show={showModal}
        onClose={handleModalClose}
        onSave={handleModalSave}
        initialValue={inputValue}
      />
    </>
  )
}

InputGPS.propTypes = {
  inputProps: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    required: PropTypes.oneOfType([
      PropTypes.bool, 
      PropTypes.func
    ])
  }).isRequired
}
